import GoodQuestion from './goodQuestion'

export { GoodQuestion }
